
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../../ui/button';
import { format } from 'date-fns';

interface PeriodNavigationProps {
  currentDate: Date;
  period: string;
  onPrevious: () => void;
  onNext: () => void;
}

const PeriodNavigation: React.FC<PeriodNavigationProps> = ({
  currentDate,
  period,
  onPrevious,
  onNext
}) => {
  const getPeriodTitle = () => {
    if (period === 'day') {
      return format(currentDate, 'MMMM d, yyyy');
    } else if (period === 'week') {
      const startOfWeek = new Date(currentDate);
      startOfWeek.setDate(currentDate.getDate() - 6);
      return `${format(startOfWeek, 'MMM d')} - ${format(currentDate, 'MMM d, yyyy')}`;
    } else if (period === 'month') {
      return format(currentDate, 'MMMM yyyy');
    }
    return '';
  };

  return (
    <div className="flex justify-between items-center mb-6">
      <Button variant="outline" size="sm" onClick={onPrevious}>
        <ChevronLeft className="h-4 w-4 mr-1" />
        Previous {period}
      </Button>
      <h3 className="font-medium text-lg">{getPeriodTitle()}</h3>
      <Button variant="outline" size="sm" onClick={onNext}>
        Next {period}
        <ChevronRight className="h-4 w-4 ml-1" />
      </Button>
    </div>
  );
};

export default PeriodNavigation;
